import PedidoCompraAPI from '@/api/compra/pedido';

export default {
  namespaced: true,
  actions: {
    fetch_pedido_compra(_, params) {
      return PedidoCompraAPI.index(params);
    },
    get_pedido_compra(_, id) {
      return PedidoCompraAPI.show(id);
    },
    create_pedido_compra(_, data) {
      return PedidoCompraAPI.create(data);
    },
    update_pedido_compra(_, { id, data }) {
      return PedidoCompraAPI.update(id, data);
    },
    destroy_pedido_compra(_, id) {
      return PedidoCompraAPI.destroy(id);
    },
    cambiar_estado_pedido_compra(_, { id, estado }) {
      return PedidoCompraAPI.cambiarEstado(id, estado);
    },
    recibir_pedido_compra(_, { id, data }) {
      return PedidoCompraAPI.recibir(id, data);
    },
    clonar_pedido_compra(_, id) {
      return PedidoCompraAPI.clonar(id);
    },
    enviar_email_pedido_compra(_, id) {
      return PedidoCompraAPI.enviarEmail(id);
    },
    fetch_productos_pedido_compra() {
      return PedidoCompraAPI.productos();
    },
    pdf_pedido_compra(_, id) {
      return PedidoCompraAPI.pdf(id);
    },
  },
};
